import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useContext,
  memo,
  useRef,
} from "react";
import { FaSearch, FaLink } from "react-icons/fa";
import "./CodeBook.css";
import bookOpenIcon from "../../assets/bookopen.png";
import booksIcon from "../../assets/books.png";
import bookInactiveIcon from "../../assets/booksinactive.png";
import achiIcon from "../../assets/achiinedx.png";
import indexIcon from "../../assets/Index.png";
import tabularicdIcon from "../../assets/icdtabular.png";
import australianIcon from "../../assets/austrilaincode.png";
import bookIcon from "../../assets/book.png";
import icd10amIcon from "../../assets/icd10am.png";
import starsIcon from "../../assets/starts.png";
import pako from "pako";
import { CodeContext } from "../pages/Coder/Coder";
import { useDebounce } from "use-debounce";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux"; // Import useSelector
import { Spinner } from "react-bootstrap";
import Bookopen from "../../common/assets/images/book-open-02 (1).png";
import LdsRoller from "../../utils/LdsRoller";
import { green } from "@mui/material/colors";
import AustralianCodebook from "./AustralianCodebook";
import earthIcon from "../../assets/earth-asia.png";
import earthinactiveIcon from "../../assets/earth-asia-inactive.png";
import AcsReferencesCodebook from "./ACSReferencesCodebook";
import {
  setOnChangeCodeBook,
  setSelectedCodebookVersion,
  updateAcsCode,
  updateNcaCode,
} from "./redux/CodeBookSlicer";
import { useLocation, useNavigate } from "react-router-dom";
// import { clearAcsCode } from "./redux/CodeBookSlicer";
// import {  } from "./redux/CodeBookSlicer";
import {
  fetchCodebookData,
  fetchCodebookData13,
  setActiveIcon,
  setActiveTab,
  setRawSearchQuery,
  setSearchByCodeId,
  setNondraggablecode,
} from "./redux/CodeBookSlicer";
import ACSCodeBook13th from "./ACSCodeBook13th";
import { useLazyGetData2Query } from "../../store/apiSlice";
import NCADocumentViewer from "./NCADocumentViewer";
import SearchableIframe from "./documentSearch/SearchableIframe";

import { Tooltip } from "@mui/material";
const CodeBookDev = React.memo(({ isLockedCoder }) => {
  // console.log( dischargeDate," dischargeDate====================")
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const firstMatchRef = useRef(null);
  const shouldScrollRef = useRef(false);
  const {
    icd10amTabularData,
    icd10amIndexData,
    achiIndexData,
    achiTabularData,
    icd10amTabularData13,
    icd10amIndexData13,
    achiIndexData13,
    achiTabularData13,
    codeBookLoading,
    codeBookError,
    activeTab,
    activeIcon,
    rawSearchQuery,
    searchByCodeId,
    onChangeCodeBook,
  } = useSelector((state) => state.codeBook);
  //   console.log(icd10amIndexData13, "jyo1");
  // // console.log(achiTabularData13,"jyo5");
  // console.log(icd10amTabularData13, "jyo2");
  //   console.log( achiIndexData13, "jyo1");



  const [searchQuery, setSearchQuery] = useState("");
  const [droppedCodes, setDroppedCodes] = useState([]);
  const [debouncedQuery] = useDebounce(rawSearchQuery, 300);
  const [selectedReference, setSelectedReference] = useState(null);

  const { selectedCodeBookCode, selectedTabKeyCoding } =
    useContext(CodeContext);
  // const [selectedCodebookVersion, setSelectedCodebookVersion] = useState("");
  const [isUserSelectedCodebookVersion, setIsUserSelectedCodebookVersion] =
    useState(false);
  const selectedEpisode = useSelector(
    (state) => state.episodeList.selectedEpisode,
  );
  const [showReferencesDropdown, setShowReferencesDropdown] = useState(false);
  const dischargeDate = selectedEpisode?.separation_date || null;
  const isFetched12 = useSelector((state) => state.codeBook.isFetched12);
  const isFetched13 = useSelector((state) => state.codeBook.isFetched13);
  const { selectedCodebookVersion } = useSelector((state) => state.codeBook);
  const { selectedCodeDetails } = useSelector((state) => state.codeSearch);
  const nondraggablecode = useSelector(
    (state) => state.codeBook.nondraggablecode,
  );
  // console.log(data,"selectedCodeDetails");
  useEffect(() => {
    if (!isUserSelectedCodebookVersion) {
      if (!dischargeDate) {
        // Discharge date missing → default to 13th
        dispatch(setSelectedCodebookVersion("13th"));
      } else {
        const discharge = new Date(dischargeDate);
        const cutoff = new Date("01-07-2025");

        // discharge <= June 30, 2025 → 12th; else → 13th
        if (discharge < cutoff) {
          dispatch(setSelectedCodebookVersion("12th"));
        } else {
          dispatch(setSelectedCodebookVersion("13th"));
        }
      }
    }
  }, [dischargeDate, isUserSelectedCodebookVersion]);

  // Clear on tab change
useEffect(() => {
  dispatch(setRawSearchQuery(""));
  dispatch(setSearchByCodeId(null));
  dispatch(setNondraggablecode(false));
  dispatch(setOnChangeCodeBook(false));
}, [activeTab, dispatch]);

  const handleChange = (e) => {
    dispatch(setSelectedCodebookVersion(e.target.value));
    setIsUserSelectedCodebookVersion(true);
  };

  // This depends on your selected edition
  // useEffect(() => {
  //   if (selectedCodebookVersion === "12th" && !isFetched12) {
  //     dispatch(fetchCodebookData());
  //   } else if (selectedCodebookVersion === "13th" && !isFetched13) {
  //     dispatch(fetchCodebookData13());
  //   }
  // }, [selectedCodebookVersion, isFetched12, isFetched13, dispatch]);
  // useEffect(() => {
  //   const shouldFetch12 =
  //     selectedCodebookVersion === "12th" &&
  //     !isFetched12;

  //   const shouldFetch13 =
  //     selectedCodebookVersion === "13th" &&
  //     !isFetched13;

  //   if (shouldFetch12) {
  //     dispatch(fetchCodebookData());
  //   } else if (shouldFetch13) {
  //     dispatch(fetchCodebookData13());
  //   }
  // }, [selectedCodebookVersion, isFetched12, isFetched13, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      if (selectedCodebookVersion === "12th" && !isFetched12) {
        dispatch(fetchCodebookData());
      } else if (selectedCodebookVersion === "13th" && !isFetched13) {
        dispatch(fetchCodebookData13());
      }
    };

    fetchData();
  }, [selectedCodebookVersion, isFetched12, isFetched13, dispatch]);

  const tabsConfig = useMemo(() => {
    const is13 = selectedCodebookVersion === "13th";
    return [
      {
        name: "ICD 10 AM Index",
        data: is13 ? icd10amIndexData13 : icd10amIndexData,
      },
      {
        name: "ICD 10 AM Tabular",
        data: is13 ? icd10amTabularData13 : icd10amTabularData,
      },
      {
        name: "ACHI Tabular",
        data: is13 ? achiTabularData13 : achiTabularData,
      },
      { name: "ACHI Index", data: is13 ? achiIndexData13 : achiIndexData },
      { name: "Australian Coding Standard", data: [] },
      { name: "Additional References", data: [] },
    ];
  }, [
    selectedCodebookVersion,
    icd10amIndexData,
    icd10amTabularData,
    achiTabularData,
    achiIndexData,
    icd10amIndexData13,
    icd10amTabularData13,
    achiTabularData13,
    achiIndexData13,
  ]);

  const getTabError = () => {
    if (!codeBookError) return null;
    switch (activeTab) {
      case "ICD 10 AM Tabular":
        return codeBookError.icd10amTabular
          ? `Failed to load ICD 10 AM Tabular data: ${codeBookError.icd10amTabular}`
          : null;
      case "ICD 10 AM Index":
        return codeBookError.icd10amIndex
          ? `Failed to load ICD 10 AM Index data: ${codeBookError.icd10amIndex}`
          : null;
      case "ACHI Tabular":
        return codeBookError.achiTabular
          ? `Failed to load ACHI Tabular data: ${codeBookError.achiTabular}`
          : null;
      case "ACHI Index":
        return codeBookError.achiIndex
          ? `Failed to load ACHI Index data: ${codeBookError.achiIndex}`
          : null;
      default:
        return null;
    }
  };

  const tabError = getTabError();

  useEffect(() => {
    const savedActiveTab = sessionStorage.getItem("activeTab");
    const savedActiveIcon = sessionStorage.getItem("activeIcon");

    if (savedActiveTab) {
      dispatch(setActiveTab(savedActiveTab)); // Set active tab if saved in sessionStorage
    }

    if (savedActiveIcon) {
      dispatch(setActiveIcon(savedActiveIcon)); // Set active icon if saved in sessionStorage
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem("activeTab", activeTab); // Save active tab to sessionStorage
    sessionStorage.setItem("activeIcon", activeIcon); // Save active icon to sessionStorage
  }, [activeTab, activeIcon]);

  useEffect(() => {
    // --- Priority 1: CodeAssist search state ---
    if (selectedCodeDetails) {
      dispatch(setSelectedCodebookVersion("13th")); // force 13th

      const { category, code_id, value, isFromTabular } = selectedCodeDetails;
      dispatch(setSearchByCodeId(code_id));
      dispatch(setRawSearchQuery(value));
      if (category === "Additional Diagnoses") {
        if (!isFromTabular) {
          // Case 1: Additional Diagnoses from Index
          dispatch(setActiveIcon("ICD"));
          dispatch(setActiveTab("ICD 10 AM Index"));
          dispatch(setRawSearchQuery(value));
          return;
        } else {
          // Case 2: Additional Diagnoses from Tabular
          dispatch(setActiveIcon("Tabular"));
          dispatch(setActiveTab("ICD 10 AM Tabular"));
          dispatch(setRawSearchQuery(value));
          return;
        }
      }
      if (category === "Principal Diagnosis") {
        if (!isFromTabular) {
          // Case 1: Additional Diagnoses from Index
          dispatch(setActiveIcon("ICD"));
          dispatch(setActiveTab("ICD 10 AM Index"));
          dispatch(setRawSearchQuery(value));
          return;
        } else {
          // Case 2: Additional Diagnoses from Tabular
          dispatch(setActiveIcon("Tabular"));
          dispatch(setActiveTab("ICD 10 AM Tabular"));
          dispatch(setRawSearchQuery(value));
          return;
        }
      }
      if (category === "Procedure Codes") {
        if (!isFromTabular) {
          // Case 1: Additional Diagnoses from Index
          dispatch(setActiveIcon("ICD"));
          dispatch(setActiveTab("ACHI Index"));
          dispatch(setRawSearchQuery(value));
          return;
        } else {
          // Case 2: Additional Diagnoses from Tabular
          dispatch(setActiveIcon("Tabular"));
          dispatch(setActiveTab("ACHI Tabular"));
          dispatch(setRawSearchQuery(value));
          return;
        }
      }
    }
    // --- Priority 2: Normal flow ---
    if (selectedCodeBookCode && selectedTabKeyCoding) {
      // console.log(selectedCodeBookCode,"selectedCodeBookCode")
      dispatch(setSearchByCodeId(null));
      // Check both are available
      dispatch(setRawSearchQuery(selectedCodeBookCode));
      if (selectedTabKeyCoding === "ACHI") {
        dispatch(setActiveIcon("Tabular")); // Or your preferred ACHI icon
        dispatch(setActiveTab("ACHI Tabular")); // Correct tab for ACHI
      } else {
        // Either ICD or default (ICD)
        dispatch(setActiveIcon("Tabular"));
        dispatch(setActiveTab("ICD 10 AM Tabular")); // Correct tab for ICD (and default)
      }
    } else {
      dispatch(setSearchByCodeId(null));
      dispatch(setRawSearchQuery(""));
      dispatch(setActiveIcon("ICD"));
      dispatch(setActiveTab("ICD 10 AM Index"));
    }
  }, [selectedCodeDetails, selectedCodeBookCode, selectedTabKeyCoding]);

  useEffect(() => {
    if (debouncedQuery?.length >= 2) {
      setSearchQuery(debouncedQuery);
    } else {
      setSearchQuery("");
    }
  }, [debouncedQuery]);

  // const filterData = (items, query) => {
  //   // if (!query) return items; // Return original items if query is empty
  //   if (!query || query.length < 3) return items; // Return empty array

  //   const lowerCaseQuery = typeof query === "string" ? query.toLowerCase() : ""; // Handle anything

  //   const results = [];
  //   const filterRecursive = (items) => {
  //     // Inner recursive function
  //     return items
  //       .map((item) => {
  //         const filteredChildren = item.children
  //           ? filterRecursive(item.children)
  //           : [];
  //         const matchesParent =
  //           (item.name && item.name.toLowerCase().includes(lowerCaseQuery)) ||
  //           (item.description &&
  //             item.description.toLowerCase().includes(lowerCaseQuery));

  //         // const matches = matchesParent || filteredChildren.length > 0;

  //         const childrenToInclude = matchesParent
  //           ? item.children || []
  //           : filteredChildren;

  //         return {
  //           ...item,
  //           // children: filteredChildren,
  //           // matches,
  //           children: childrenToInclude, // Preserve all children if parent matches
  //           matches: matchesParent || childrenToInclude.length > 0,
  //         };
  //       })
  //       .filter((item) => item.matches || item.children?.length > 0);
  //   };

  //   return filterRecursive(items);
  // };

  const filterData = (items, query, codeId = null) => {
    // If we have a specific code ID to search for
    if (codeId) {
      const findByIdRecursive = (items, targetId) => {
        for (const item of items) {
          // Check if this item matches the target ID
          if (item.id === targetId) {
            return [item]; // Return only the matching item
          }

          // Check children recursively
          if (item.children) {
            const foundInChildren = findByIdRecursive(item.children, targetId);
            if (foundInChildren.length > 0) {
              // Return the parent with only the matching child
              return [
                {
                  ...item,
                  children: foundInChildren,
                  matches: true,
                },
              ];
            }
          }
        }
        return [];
      };

      return findByIdRecursive(items, codeId);
    }

    // Original text-based search (fallback)
    if (!query || query.length < 2) return items;

    const lowerCaseQuery = typeof query === "string" ? query.toLowerCase() : "";

    // ---------------- NORMALIZATION ----------------
    const normalize = (str = "") => {
      return str
        .toLowerCase()
        .replace(/\b(see|see also).*$/i, "") // remove "see..." references
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // remove accents
        .replace(/['’]/g, "") // remove apostrophes
        .replace(/[()]/g, " ") // keep words inside ()
        .replace(/-/g, " ") // split hyphens
        .replace(/[^a-z0-9\s]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    };

    const tokenize = (str) => normalize(str).split(" ").filter(Boolean);

    // prepare query once
    const queryNorm = normalize(lowerCaseQuery);
    const queryTokens = tokenize(lowerCaseQuery);

    // ---------------- MATCH FUNCTION ----------------
    const matchText = (text = "") => {
      if (!text) return null;

      const textNorm = normalize(text);
      const queryNormTrimmed = queryNorm.trim();

      // Exact full match
      if (textNorm === queryNormTrimmed) return "exact";

      // always checks for starting terms
      if (textNorm.startsWith(queryNormTrimmed)) return "partial";
      const segments = textNorm.split(",").map((s) => s.trim());
      const firstTokensOfSegments = segments
        .map((s) => s.split(" ")[0])
        .filter(Boolean);

      const matchesSegmentStart = firstTokensOfSegments.some((token) =>
        token.startsWith(queryNormTrimmed),
      );

      if (matchesSegmentStart) return "partial";

      return null;
    };

    const filterRecursive = (items) => {
      const result = items
        .map((item) => {
          const filteredChildren = item.children
            ? filterRecursive(item.children)
            : [];
          const isTabularHyphenSearch = nondraggablecode;

          const matchType = isTabularHyphenSearch
            ? item.name
              ? matchText(item.name)
              : null
            : (item.name && matchText(item.name)) ||
              (item.description && matchText(item.description));
          const matchesParent = !!matchType;
          let childrenToInclude = [];

          if (activeTab === "ICD 10 AM Index" && !/\d/.test(lowerCaseQuery)) {
            childrenToInclude = matchesParent
              ? item.children || []
              : onChangeCodeBook
                ? []
                : filteredChildren;
          } else {
            childrenToInclude = matchesParent
              ? item.children || []
              : filteredChildren;
          }

          return {
            ...item,
            children: childrenToInclude,
            matches: matchesParent || childrenToInclude.length > 0,
            matchType, // 👈 important
          };
        })
        .filter((item) => item.matches || item.children?.length > 0);
      const hasExact = result.some((item) => item.matchType === "exact");
      if (hasExact) {
        return result.filter((item) => item.matchType === "exact");
      }
      return result;
    };

    return filterRecursive(items);
  };

  // const filteredDataMemo = useMemo(() => {
  //   const currentTabData = tabsConfig.find(
  //     (tab) => tab.name === activeTab
  //   )?.data;
  //   return filterData(currentTabData || [], searchQuery);
  // }, [activeTab, searchQuery, tabsConfig]);
  const filteredDataMemo = useMemo(() => {
    const currentTabData = tabsConfig.find(
      (tab) => tab.name === activeTab,
    )?.data;

    return filterData(currentTabData || [], searchQuery, searchByCodeId);
  }, [activeTab, searchQuery, searchByCodeId, tabsConfig]);

  const handleSearchChange = (e) => {
    // console.log('seeins', e.target.value);
    if (e.target.value) {
      dispatch(setOnChangeCodeBook(true));
    } else {
      dispatch(setOnChangeCodeBook(false));
    }

    const newValue = e.target.value;
    if (newValue !== rawSearchQuery) {
      dispatch(setRawSearchQuery(newValue));
      dispatch(setNondraggablecode(false));
      // dispatch(setSearchByCodeId(null))
      if (searchByCodeId) dispatch(setSearchByCodeId(null));
    }
    // console.log('onChangeCodeBook');
  };

  const handleIconClick = (icon) => {
    dispatch(setActiveIcon(icon))
    dispatch(setSearchByCodeId(null))
    dispatch(setRawSearchQuery(""))
    if (icon === "ICD") dispatch(setActiveTab("ICD 10 AM Index"))
    else if (icon === "Tabular") dispatch(setActiveTab("ICD 10 AM Tabular"))
    else if (icon === "Coding") {
      dispatch(updateAcsCode(""));
      dispatch(setActiveTab("Australian Coding Standard"));
      dispatch(updateNcaCode(""));
    } else if (icon === "References")
      dispatch(setActiveTab("Additional References"));
      dispatch(updateAcsCode(""));
      dispatch(updateNcaCode(""));


    // if (icon !== "Coding") {
    //   navigate('/coder')
    // };
  };

  const getIcon = (icon) => {
    if (icon === "ICD") {
      return activeTab === "ICD 10 AM Index"
        ? booksIcon
        : activeTab === "ACHI Index"
          ? achiIcon
          : bookInactiveIcon; // Inactive icon for ICD
    }

    if (icon === "Tabular") {
      return activeTab === "ICD 10 AM Tabular"
        ? tabularicdIcon
        : activeTab === "ACHI Tabular"
          ? icd10amIcon
          : bookInactiveIcon; // Inactive icon for Tabular
    }

    if (icon === "Coding") {
      return activeTab === "Australian Coding Standard"
        ? australianIcon
        : bookIcon;
    }
    if (icon === "References") {
      return activeTab === "Additional References" ? earthIcon : earthIcon;
    }

    return bookInactiveIcon;
  };

  const getTooltipTitle = (icon) => {
    const edition =
      selectedCodebookVersion === "12th"
        ? "Twelfth Edition"
        : "Thirteenth Edition";
    switch (icon) {
      case "ICD":
        return activeTab === "ACHI Index"
          ? `ACHI Alphabetic Index ${edition}`
          : `ICD-10-AM Alphabetic Index ${edition}`;

      case "Tabular":
        return activeTab === "ACHI Tabular"
          ? `ACHI Tabular List ${edition}`
          : `ICD-10-AM Tabular List ${edition}`;

      case "Coding":
        return `Australian Coding Standards ${edition}`;

      default:
        return "";
    }
  };

  const handleDrop = (code) => {
    setDroppedCodes((prev) => [...prev, code]);
  };

  const [displayedItems, setDisplayedItems] = useState([]); // Items to render
  const [loadMore, setLoadMore] = useState(50); // Number of items to load
  const searchResultsRef = React.useRef(null);
  useEffect(() => {
    setLoadMore(50);
  }, [activeTab, searchQuery, selectedCodebookVersion]);
  useEffect(() => {
    setDisplayedItems(filteredDataMemo?.slice(0, loadMore));
  }, [filteredDataMemo, loadMore]);
  // console.log(displayedItems,filteredDataMemo,'displayedItemsdisplayedItems');

  const handleScroll = useCallback(() => {
    if (!searchResultsRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = searchResultsRef.current;

    // If scrolled to the bottom, load 10 more items
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      setLoadMore((prev) => prev + 10);
    }
  }, []);

  useEffect(() => {
    const element = searchResultsRef.current;
    if (element) {
      element.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (element) {
        element.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll,activeIcon,activeTab]);
  // useEffect(()=>{
  //   console.log(onChangeCodeBook,'onChangeCodeBook');

  // },[onChangeCodeBook])

  useEffect(() => {
    firstMatchRef.current = null;
    shouldScrollRef.current = !!(searchQuery || searchByCodeId);
    if (searchResultsRef.current) {
      searchResultsRef.current.scrollTop = 0;
    }
  }, [activeTab, selectedCodebookVersion, searchQuery, searchByCodeId]);

  // EFFECT 2 — Scroll only when allowed
  useEffect(() => {
    if (!shouldScrollRef.current) return;
    if (!searchQuery && !searchByCodeId) return;

    let scrollDone = false;
    const timerIds = [];

    const tryScroll = (delay) => {
      const id = setTimeout(() => {
        if (scrollDone) return;
        if (!shouldScrollRef.current) return;
        if (!firstMatchRef.current || !searchResultsRef.current) return;

        const containerTop =
          searchResultsRef.current.getBoundingClientRect().top;
        const elementTop = firstMatchRef.current.getBoundingClientRect().top;
        const scrollOffset = elementTop - containerTop;

        if (Math.abs(scrollOffset) > 5) {
          searchResultsRef.current.scrollTop =
            searchResultsRef.current.scrollTop + scrollOffset - 20;
        }
        scrollDone = true;
      }, delay);
      timerIds.push(id);
    };

    const onManualScroll = () => {
      scrollDone = true;
      shouldScrollRef.current = false;
    };
    searchResultsRef.current?.addEventListener("scroll", onManualScroll, {
      once: true,
    });

    tryScroll(500);
    tryScroll(800);
    tryScroll(1100);
    return () => {
      timerIds.forEach(clearTimeout);
      searchResultsRef.current?.removeEventListener("scroll", onManualScroll);
    };
  }, [displayedItems]);
  return (
    <div className="codebook-container">
      <div className="codebook1-header">
        <span
          className={`header-navicon ${
            activeIcon === "ICD" ? "active-icon" : ""
          }`}
          onClick={() => handleIconClick("ICD")}
        >
          {/* <img src={getIcon("ICD")} alt="ICD Icon" width={30} height={30} /> */}
          <Tooltip title={getTooltipTitle("ICD")}>
            <span>
              <img src={getIcon("ICD")} alt="ICD Icon" width={30} height={30} />
            </span>
          </Tooltip>
        </span>
        <span
          className={`header-navicon ${
            activeIcon === "Tabular" ? "active-icon" : ""
          }`}
          onClick={() => handleIconClick("Tabular")}
        >
          <Tooltip title={getTooltipTitle("Tabular")}>
            <span>
              <img
                src={getIcon("Tabular")}
                alt="Tabular Icon"
                width={30}
                height={30}
              />
            </span>
          </Tooltip>
        </span>
        <span
          className={`header-navicon ${
            activeIcon === "Coding" ? "active-icon" : ""
          }`}
          onClick={() => handleIconClick("Coding")}
        >
          <Tooltip title={getTooltipTitle("Coding")}>
            <span>
              <img
                src={getIcon("Coding")}
                alt="Coding Icon"
                width={30}
                height={30}
              />
            </span>
          </Tooltip>
        </span>

        <span
          className={`header-navicon ${
            activeIcon === "References" ? "active-icon" : ""
          } ${codeBookLoading ? "disabled-icon" : ""}`}
          onClick={() => {
            if (!codeBookLoading) {
              setShowReferencesDropdown((prev) => !prev);
            }
          }}
          style={{
            pointerEvents: codeBookLoading ? "none" : "auto",
            opacity: codeBookLoading ? 0.5 : 1,
            cursor: codeBookLoading ? "not-allowed" : "pointer",
          }}
        >
          <img
            src={getIcon("References")}
            alt="Coding Icon"
            width={20}
            height={20}
          />
        </span>
        {showReferencesDropdown && (
          <div className="references-dropdown">
            <div
              className="dropdown-item"
              onClick={() => {
                setSelectedReference("morphology");
                dispatch(setActiveIcon("References"));
                dispatch(setActiveTab("Morphology"));
                dispatch(setRawSearchQuery(""))
                setShowReferencesDropdown(false);
              }}
            >
              Morphology
            </div>

            <div
              className="dropdown-item"
              onClick={() => {
                setSelectedReference("nationalCoding");
                dispatch(setActiveIcon("References"));
                dispatch(setActiveTab("National Coding Advice"));
                dispatch(setRawSearchQuery(""))
                setShowReferencesDropdown(false);
              }}
            >
              National Coding Advice
            </div>
            <div
              className="dropdown-item"
              onClick={() => {
                setSelectedReference("StateAdvice-NSW");
                dispatch(setActiveIcon("References"));
                dispatch(setActiveTab("StateAdvice-NSW"));
                dispatch(setRawSearchQuery(""))
                setShowReferencesDropdown(false);
              }}
            >
              State Advice - NSW
            </div>
            <div
              className="dropdown-item"
              onClick={() => {
                setSelectedReference("StateAdvice-VIC");
                dispatch(setActiveIcon("References"));
                dispatch(setActiveTab("StateAdvice-VIC"));
                dispatch(setRawSearchQuery(""))
                setShowReferencesDropdown(false);
              }}
            >
              State Advice - VIC
            </div>
            <div
              className="dropdown-item"
              onClick={() => {
                setSelectedReference("StateAdvice-QLD");
                dispatch(setActiveIcon("References"));
                dispatch(setActiveTab("StateAdvice-QLD"));
                dispatch(setRawSearchQuery(""))
                setShowReferencesDropdown(false);
              }}
            >
              State Advice - QLD
            </div>
          </div>
        )}
        <span style={{ marginLeft: "auto" }}>
          <select
            className="codebook-version-select"
            value={selectedCodebookVersion}
            onChange={handleChange}
          >
            <option value="12th">12th</option>
            <option value="13th">13th</option>
          </select>
        </span>
      </div>

      <div className="tabs-codes">
        {activeIcon === "ICD" && (
          <>
            <button
              className={activeTab === "ICD 10 AM Index" ? "active" : ""}
              style={{
                borderBottomColor:
                  activeTab === "ICD 10 AM Index" ? "#FFE404" : "transparent",
              }}
              onClick={() => dispatch(setActiveTab("ICD 10 AM Index"))}
            >
              ICD 10 AM Index
            </button>
            <button
              className={activeTab === "ACHI Index" ? "active" : ""}
              style={{
                borderBottomColor:
                  activeTab === "ACHI Index" ? "green" : "transparent",
              }}
              onClick={() => dispatch(setActiveTab("ACHI Index"))}
            >
              ACHI Index
            </button>
          </>
        )}
        {activeIcon === "Tabular" && (
          <>
            <button
              className={activeTab === "ICD 10 AM Tabular" ? "active" : ""}
              style={{
                borderBottomColor:
                  activeTab === "ICD 10 AM Tabular" ? "red" : "transparent",
              }}
              onClick={() => dispatch(setActiveTab("ICD 10 AM Tabular"))}
            >
              ICD 10 AM Tabular
            </button>
            <button
              className={activeTab === "ACHI Tabular" ? "active" : ""}
              style={{
                borderBottomColor:
                  activeTab === "ACHI Tabular" ? "blue" : "transparent",
              }}
              onClick={() => dispatch(setActiveTab("ACHI Tabular"))}
            >
              ACHI Tabular
            </button>
          </>
        )}
        {activeIcon === "Coding" && (
          <button
            className={
              activeTab === "Australian Coding Standard" ? "active" : ""
            }
            style={{ borderBottomColor: "purple" }}
          >
            Australian Coding Standards (ACS)
          </button>
        )}
        {activeIcon === "References" && (
          <button
            className={activeTab === "National Coding Advice" ? "active" : ""}
            style={{ borderBottomColor: "blue" }}
          >
            Additional References
          </button>
        )}
      </div>

      {/* <div className="search-bar-code">
        <FaSearch className="search-icon" />
        <input
          type="text"
          className="search-input"
          placeholder="Search by code or description"
          value={rawSearchQuery}
          onChange={handleSearchChange}
        />
 
      </div> */}
      {
        <div className="search-bar-code">
          <FaSearch className="codebook-search-icon" />
          <input
            type="text"
            className="search-input"
            placeholder="Search by code or description"
            value={rawSearchQuery}
            onChange={handleSearchChange}
          />
        </div>
        
      }
            {/* ====================== SEARCH BAR WITH CONDITION ====================== */}
      {activeTab === "Morphology" && (
        <div className="pdf-container" style={{ height: "calc(100vh - 380px)" }}>
          {/* <iframe
            src="/documents/DxTabAppendixA.html"
            width="100%"
            style={{ height: "calc(100vh - 380px)" }}
            title="Morphology"
          /> */}
           <SearchableIframe
      src="/documents/DxTabAppendixA.html"
      title="Morphology"
      query={rawSearchQuery}

    />
        </div>
      )}
      {activeTab === "StateAdvice-NSW" && (
        <div className="pdf-container" style={{ height: "calc(100vh - 380px)" }}>
          {/* <iframe
            src="/documents/NSW_State.html"
            width="100%"
            style={{ height: "calc(100vh - 380px)" }}
            title="StateAdvice"
          /> */}
           <SearchableIframe
      src="/documents/NSW_State.html"
      title="State Advice NSW"
            query={rawSearchQuery}

    />
        </div>
      )}
      {activeTab === "StateAdvice-VIC" && (
        <div className="pdf-container" style={{ height: "calc(100vh - 380px)" }}>
          {/* <iframe
            src="/documents/VICC.html"
            width="100%"
            style={{ height: "calc(100vh - 380px)" }}
            title="StateAdvice"
          /> */}
           <SearchableIframe
      src="/documents/NSW_State.html"
      title="State Advice NSW"
            query={rawSearchQuery}

    />
        </div>
      )}
         {activeTab === "StateAdvice-QLD" && (
        <div className="pdf-container" style={{ height: "calc(100vh - 380px)" }}>
          {/* <iframe
            src="/documents/QLD.html"
            width="100%"
            style={{ height: "calc(100vh - 380px)" }}
            title="StateAdvice"
          /> */}
           <SearchableIframe
      src="/documents/VICC.html"
      title="State Advice VIC"
            query={rawSearchQuery}
    />
        </div>
      )}

      {activeTab === "National Coding Advice" && (
  <div className="pdf-container">
    <NCADocumentViewer query={rawSearchQuery}/>
  </div>
)}
      {activeTab === "Australian Coding Standard" ? (
          <div className="acs-wrapper">
       { selectedCodebookVersion === "12th" ? (
          <AustralianCodebook searchQuery={rawSearchQuery}/>
        ) : (
          <ACSCodeBook13th  query={rawSearchQuery}/>
        )}
        </div>
      ) : (
        ![
          "National Coding Advice",
          "Morphology",
          "StateAdvice-NSW",
          "StateAdvice-VIC",
          "StateAdvice-QLD",
        ].includes(activeTab) && (
          <div className="search-results" ref={searchResultsRef}>
            {/* {activeTab === "Australian Coding Standard" && <AustralianCodebook />} */}
            <div className="accordion-container">
              {/* {
            codeBookLoading ? <div className="codebook-loader">
              <Spinner />{" "}
            </div> : <>
              {displayedItems.map((item,index) => (<AccordionItem key={index} item={item} searchQuery={searchQuery} activeTab={activeTab} />))}
            </>
          } */}
              {(() => {
                // Check if data is actually available in IndexedDB
                const hasData =
                  selectedCodebookVersion === "13th"
                    ? icd10amIndexData13?.length > 0 ||
                      achiIndexData13?.length > 0
                    : icd10amIndexData?.length > 0 || achiIndexData?.length > 0;

                // Check sessionStorage
                const isFetched =
                  selectedCodebookVersion === "13th"
                    ? sessionStorage.getItem("isFetched13") === "true"
                    : sessionStorage.getItem("isFetched12") === "true";

                // Only show loader if NO data is available
                const showInternalLoader =
                  (codeBookLoading ||
                    (selectedCodebookVersion === "12th" && !isFetched12) ||
                    (selectedCodebookVersion === "13th" && !isFetched13)) &&
                  !hasData &&
                  !isFetched;

                if (showInternalLoader) {
                  return (
                    <div className="codebook-loader">
                      <LdsRoller />
                    </div>
                  );
                }

                // Show the actual content
                return (
                  <>
                    {displayedItems.length > 0
                      ? displayedItems.map((item, index) => (
                          <AccordionItem
                            key={index}
                            item={item}
                            searchByCodeId={searchByCodeId}
                            searchQuery={searchQuery}
                            activeTab={activeTab}
                            isTopLevel={item.children.length === 0}
                            setActiveTab={setActiveTab}
                            dispatch={dispatch}
                            setActiveIcon={setActiveIcon}
                            isLockedCoder={isLockedCoder}
                            firstMatchRef={firstMatchRef}
                          />
                        ))
                      : searchQuery.length >= 2 &&
                        activeTab !== "National Coding Advice" &&
                        activeTab !== "Morphology" &&
                        activeTab !== "StateAdvice-NSW" &&
                        activeTab !== "StateAdvice-VIC" &&
                        activeTab !== "StateAdvice-QLD" && (
                          <div>No matches found</div>
                        )}
                  </>
                );
              })()}
            </div>

            {/* <div className="staricon">
            <img src={starsIcon} alt="Star Icon" />
        </div> */}
          </div>
        )
      )}
    </div>
  );
});

const getItemCodes = (item, activeTab) => {
  const codeString = getItemCode(item, activeTab); // Get the combined code string
  if (!codeString) return []; // Handle cases where codeString is empty or null
  if (activeTab === "ACHI Tabular" || activeTab === "ACHI Index") {
    // ACHI: Return the entire string as one code, regardless of brackets.
    return [codeString];
  } else {
    // ICD: Split by common delimiters, but ONLY if they are OUTSIDE brackets.
    const delimiter = /[†* ,]+(?![^[]*\])/; // Split outside of brackets
    const codes = codeString
      .split(delimiter)
      .filter((code) => code.trim() !== "");
    return codes;
  }
};

const getItemCode = (item, activeTab) => {
  switch (activeTab) {
    case "ICD 10 AM Index":
    case "ACHI Index":
      return item.description;
    case "ICD 10 AM Tabular":
    case "ACHI Tabular":
    case "Australian Coding Standard":
      return item.name;
    default:
      return item.name;
  }
};
// const highlightText = (text, query) => {

//   if (!query || query.length < 3 || !text) {
//     return text; // Return original text if query is empty or too short
//   }

//   const lowerCaseText = text.toLowerCase();
//   const lowerCaseQuery = query.toLowerCase();

//   const parts = [];
//   let lastIndex = 0;

//   while (true) {
//     const index = lowerCaseText.indexOf(lowerCaseQuery, lastIndex);
//     if (index === -1) {
//       parts.push(text.substring(lastIndex));
//       break;
//     }

//     parts.push(text.substring(lastIndex, index));
//     parts.push(
//       <span className="highlighted">
//         {text.substring(index, index + query.length)}
//       </span>
//     );
//     lastIndex = index + query.length;
//   }

//   return parts;
// };
const highlightText = (text, query, onChangeCodeBook = false) => {
  // console.log(onChangeCodeBook,'cskdhsjdhgfsedf');

  if (!query || query.length < 2 || !text) {
    return text;
  }

  // Escape special regex characters
  const escapedQuery = query.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  // If onChangeCodeBook is true, do substring match; else exact match
  const regex = onChangeCodeBook
    ? new RegExp(escapedQuery, "i") // substring match
    : new RegExp(`^${escapedQuery}$`);

  if (regex.test(text)) {
    return <span className="highlighted">{text}</span>;
  }
  return text;
};
const handleDragStartLogic = (e, draggableCodes, activeTab) => {
  if (draggableCodes.length > 0) {
    const dragData = {
      codes: draggableCodes,
      tab: activeTab,
    };
    e.dataTransfer.setData("application/json", JSON.stringify(dragData));
    e.dataTransfer.setData("text/plain", JSON.stringify(draggableCodes));
    e.dataTransfer.setData(
      "text/uri-list",
      `data:text/plain;charset=utf-8,${encodeURIComponent(
        JSON.stringify(draggableCodes),
      )}`,
    );
    // console.log("Dragging medical codes:", dragData.codes, "from tab:", dragData.tab);
  } else {
    e.preventDefault();
  }
};

const AccordionItem = ({
  item,
  activeTab,
  searchQuery,
  searchByCodeId,
  isTopLevel,
  dispatch,
  setActiveTab,
  setActiveIcon,
  isLockedCoder,
  nondraggablecode,
  firstMatchRef,
}) => {
  const { copiedCodes, setCopiedCodes } = useContext(CodeContext);
  const [isCopied, setIsCopied] = useState(false);
  const [localIsOpen, setLocalIsOpen] = useState(false);

  const { onChangeCodeBook } = useSelector((state) => state.codeBook);

  const isHighlightedById = searchByCodeId && item.id === searchByCodeId;
  useEffect(() => {
    if (searchByCodeId) {
      if (
        item.id === searchByCodeId ||
        (item.children &&
          item.children.some((child) => child.id === searchByCodeId))
      ) {
        setLocalIsOpen(true);
      }
    } else if (
      searchQuery.length > 1 &&
      item.children?.some((child) => child.matches)
    ) {
      setLocalIsOpen(true);
    } else if (searchQuery.length < 2) {
      setLocalIsOpen(false); // Close if no search or short query
    }
  }, [searchQuery, item.children]);
  useEffect(() => {
    if (searchQuery.length > 1) {
      // Check if the item or any of its descendants have matches
      const hasMatches =
        item.matches ||
        item.children?.some(
          (child) => child.matches || child.children?.some((c) => c.matches),
        );
      setLocalIsOpen(hasMatches);
    } else {
      setLocalIsOpen(false);
    }
  }, [searchQuery, searchByCodeId, item.children, item.id]);
  // useEffect(() => {
  //   if (
  //     searchQuery.length > 2 &&
  //     item.children?.some((child) => child.matches)
  //   ) {
  //     setLocalIsOpen(true); // Auto-open only if a child matches
  //   } else if (searchQuery.length < 3) {
  //     setLocalIsOpen(false); // Close if no search or short query
  //   }
  // }, [searchQuery, item.children]);
  // useEffect(() => {
  //   if (searchQuery.length > 1) {
  //     // Check if the item or any of its descendants have matches
  //     const hasMatches = item.matches || (item.children?.some(child => child.matches || child.children?.some(c => c.matches)));
  //     setLocalIsOpen(hasMatches);
  //   } else {
  //     setLocalIsOpen(false);
  //   }
  // }, [searchQuery, item]);

  //     useEffect(() => {
  //   if (searchQuery.length > 1) {
  //     // Only open if a *child* matches, not when the parent itself matches
  //     const childHasMatches =
  //       item.children?.some(
  //         (child) => child.matches || child.children?.some((c) => c.matches)
  //       ) || false;

  //     // Open only if a descendant matched
  //     setLocalIsOpen(childHasMatches);
  //   } else {
  //     setLocalIsOpen(false);
  //   }
  // }, [searchQuery, item]);

  const toggleOpen = () => {
    setLocalIsOpen(!localIsOpen);
  };

  const handleAcsFunction = (acsCode) => {
    // console.log("navigate click");
    dispatch(updateAcsCode(acsCode));
    dispatch(setActiveTab("Australian Coding Standard"));
    dispatch(setActiveIcon("Coding"));
  };
  const handleNationalSearchRef = (ncaCode) => {
    dispatch(updateNcaCode(null));
    setTimeout(() => {
      dispatch(updateNcaCode(ncaCode));
    }, 0);
    dispatch(setActiveIcon("References"));
    dispatch(setActiveTab("National Coding Advice"));
  };

  const codes = getItemCodes(item, activeTab);
  const draggableCodes = codes.filter((code) => {
    if (activeTab === "ACHI Tabular" || activeTab === "ACHI Index") {
      // return true;
      return code.includes("-");
    } else {
      return !code.includes("-");
    }
  });

  // Non drggable code functionlity -Hyphen codes
  const isHyphenExtensionCode = (code = "") => {
    if (typeof code !== "string") return false;

    // Matches:
    // Z50.3-       → trailing hyphen
    // A23.-†, A23.-+, M49.1-* → special hyphen
    return code.endsWith("-") || /-\*|-\+|-\†$/.test(code);
  };

  const handleCodeClick = (code) => {
    if (!code) return;
    if (activeTab === "ACHI Tabular" || activeTab === "ACHI Index") return;

    let cleanedCode = code.trim();

    // Remove trailing -†, -*, -+
    cleanedCode = cleanedCode.replace(/-[†*+]$/, "");

    // Remove trailing simple hyphen
    if (cleanedCode.endsWith("-")) {
      cleanedCode = cleanedCode.slice(0, -1);
    }

    // console.log("Clicked code cleaned:", cleanedCode);
    dispatch(setSearchByCodeId(null));
    dispatch(setNondraggablecode(true));
    dispatch(setActiveIcon("Tabular"));
    dispatch(setActiveTab("ICD 10 AM Tabular"));
    dispatch(setRawSearchQuery(cleanedCode));
  };
  const hasMixedCodes =
    item.description?.split(/\s+/).some((p) => isHyphenExtensionCode(p)) &&
    item.description?.split(/\s+/).some((p) => !isHyphenExtensionCode(p));
  // Completed
  const handleDragStart = useCallback(
    (e, draggableCodes) => {
      if (isLockedCoder) {
        e.preventDefault();
        return;
      }
      handleDragStartLogic(e, draggableCodes, activeTab);
      // console.log("Codes being dragged:", draggableCodes,activeTab);
    },
    [activeTab, isLockedCoder],
  );
  const handleCopyCode = (e) => {
    if (isLockedCoder) {
      toast.error("Episode is locked.");
      return;
    }
    if (
      (activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular") &&
      (!item.children || item.children.length === 0)
    ) {
      // Tabular view logic
      if (draggableCodes.length > 0) {
        const cleanedCodes = draggableCodes.map(
          (code) =>
            code
              ?.trim()
              .replace(/^\(+/, "") // remove leading (
              .replace(/\)+$/, ""), // remove trailing )
        );

        const codesString = cleanedCodes.join(",");
        // console.log(codesString, "copy code========");
        navigator.clipboard
          .writeText(codesString)
          .then(() => {
            setIsCopied(true);
            setCopiedCodes(codesString.split(","));
            setTimeout(() => setIsCopied(false), 3000);
          })
          .catch((err) => {
            console.error("Clipboard copy error:", err); // Log the error for debugging
            if (err instanceof Error) {
              toast.error("Failed to copy: " + err.message);
            } else {
              toast.error("Failed to copy: An unknown error occurred.");
            }
          });
      }
    } else if (
      (activeTab === "ICD 10 AM Index" || activeTab === "ACHI Index") &&
      draggableCodes.length > 0
    ) {
      // Index view logic
      const cleanedCodes = draggableCodes.map(
        (code) =>
          code
            ?.trim()
            .replace(/^\(+/, "") // remove leading (
            .replace(/\)+$/, ""), // remove trailing )
      );

      const codesString = cleanedCodes.join(",");
      // console.log(codesString, "copy code========");
      navigator.clipboard
        .writeText(codesString)
        .then(() => {
          setIsCopied(true);
          setCopiedCodes(codesString.split(","));
          setTimeout(() => setIsCopied(false), 3000);
        })
        .catch((err) => {
          // console.error("Clipboard copy error:", err); // Log the error for debugging
          if (err instanceof Error) {
            toast.error("Failed to copy: " + err.message);
          } else {
            toast.error("Failed to copy: An unknown error occurred.");
          }
        });
    }
  };
  useEffect(() => {
    return () => {
      toast.dismiss();
    };
  }, []);
  return (
    // <div key={"shbfsh"} className={`codebook-wrapper accordion-item ${isHighlightedById ? 'highlighted-item' : ''}`}>
    // REPLACE WITH
    <div
      key={"shbfsh"}
      className={`codebook-wrapper accordion-item ${isHighlightedById ? "highlighted-item" : ""}`}
      ref={
        // Attach ref only to first leaf match — no children means it's a real result
        item.matches || isHighlightedById
          ? (el) => {
              if (el && !firstMatchRef.current) firstMatchRef.current = el;
            }
          : null
      }
    >
      {isCopied && ( // Conditionally render the button
        <button className="code-copied-button">
          Code Copied{" "}
          <img src={Bookopen} alt="plus" className="codebook-copy-icon" />
        </button>
      )}
      <div className="accordion-header" onClick={toggleOpen}>
        <div
          className={`header-content ${isHighlightedById ? "highlighted-by-id" : ""}`}
        >
          {item.children?.length > 0 && (
            <span className="accordion-icon">{localIsOpen ? "▼" : "▶"}</span>
          )}
          <span
            className="item-name"
            onClick={handleCopyCode}
            draggable={
              // activeTab === "ICD 10 AM Tabular" ||
              // (activeTab === "ACHI Tabular" &&
              //   (!item.children || item.children.length === 0))
              !isLockedCoder && // Should be true when NOT locked
              (activeTab === "ICD 10 AM Tabular" ||
                (activeTab === "ACHI Tabular" &&
                  (!item.children || item.children.length === 0)))
            }
            onDragStart={
              // (activeTab === "ICD 10 AM Tabular" ||
              //   activeTab === "ACHI Tabular") &&
              // (!item.children || item.children.length === 0)
              //   ? (e) => handleDragStart(e, draggableCodes)
              //   : null
              !isLockedCoder // Should have handler when NOT locked
                ? (activeTab === "ICD 10 AM Tabular" ||
                    activeTab === "ACHI Tabular") &&
                  (!item.children || item.children.length === 0)
                  ? (e) => handleDragStart(e, draggableCodes)
                  : null
                : null
            }
            style={{
              color:
                !isLockedCoder &&
                draggableCodes.length > 0 &&
                draggableCodes.length > 0 &&
                (activeTab === "ICD 10 AM Tabular" ||
                  activeTab === "ACHI Tabular") &&
                (!item.children || item.children.length === 0)
                  ? "blue"
                  : "inherit",
              textDecoration:
                draggableCodes.length > 0 &&
                (activeTab === "ICD 10 AM Tabular" ||
                  activeTab === "ACHI Tabular") &&
                (!item.children || item.children.length === 0)
                  ? "underline"
                  : "none",
              fontWeight:
                isTopLevel || item.children?.length > 0 ? "bold" : "normal",
            }}
          >
            {highlightText(item.name, searchQuery, onChangeCodeBook)}
          </span>
          <span
            className="item-description"
            onClick={handleCopyCode}
            draggable={
              activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular"
                ? false
                : draggableCodes.length > 0
            }
            onDragStart={
              activeTab === "ICD 10 AM Tabular" || activeTab === "ACHI Tabular"
                ? null
                : draggableCodes.length > 0
                  ? (e) => handleDragStart(e, draggableCodes)
                  : null
            }
            style={{
              color:
                draggableCodes.length > 0 &&
                (activeTab === "ICD 10 AM Index" || activeTab === "ACHI Index")
                  ? "blue"
                  : "inherit",
              textDecoration:
                draggableCodes.length > 0 &&
                (activeTab === "ICD 10 AM Index" || activeTab === "ACHI Index")
                  ? "underline"
                  : "none",
            }}
          >
            {/* <span className="item-descrpition-value">
              {highlightText(item.description, searchQuery,onChangeCodeBook)}
            </span> */}
            {/* {item.description ? (
              <span className="item-descrpition-value">
                {item.description.split(/\s+/).map((rawPart, index) => {
                  const part = rawPart.trim();
                  const clickable = isHyphenExtensionCode(part) && !hasMixedCodes;

                  return (
                    <span
                      key={index}
                      className={clickable ? "code-underline" : ""}
                      onClick={() => clickable && handleCodeClick(part)}
                      style={{
                        cursor: clickable ? "pointer" : "pointer",
                         marginRight: clickable ? "8px" : "0px",
                        // textDecoration: clickable ? "underline" : "none",

                      }}
                    >
                      {highlightText(part, searchQuery, onChangeCodeBook)}
                    </span>
                  );
                })}
              </span>
            ) : null} */}

            {item.description ? (
              <span className="item-descrpition-value">
                {
                  // searchByCodeId && activeTab === "ICD 10 AM Tabular" ||
                  activeTab === "ICD 10 AM Tabular" ||
                  activeTab === "ACHI Tabular"
                    ? // ID-based → FULL description (no split)
                      highlightText(
                        item.description,
                        searchQuery,
                        onChangeCodeBook,
                      )
                    : //  Normal search → split logic (as it was)
                      item.description.split(/\s+/).map((rawPart, index) => {
                        const part = rawPart.trim();
                        const clickable =
                          isHyphenExtensionCode(part) && !hasMixedCodes;

                        return (
                          <span
                            key={index}
                            className={clickable ? "code-underline" : ""}
                            onClick={() => clickable && handleCodeClick(part)}
                            style={{ marginRight: clickable ? "8px" : "5px" }}
                          >
                            {highlightText(part, searchQuery, onChangeCodeBook)}
                          </span>
                        );
                      })
                }
              </span>
            ) : null}

            {/* {item?.acs ? (
              <span className="item-acs-value">
                {" "}
                <button
                  className="acs-btn"
                  onClick={() => {
                    //  console.log("ACS value:", item?.acs);
                    handleAcsFunction(item?.acs);
                  }}
                >
                  ACS
                </button>{" "}
              </span>
            ) : (
              ""
            )}
          </span> */}
            {item?.acs && activeTab !== "ICD 10 AM Index" ? (
              <span className="item-acs-value">
                {" "}
                <button
                  className="acs-btn"
                  onClick={() => {
                    //  console.log("ACS value:", item?.acs);
                    handleAcsFunction(item?.acs);
                  }}
                >
                  ACS
                </button>{" "}
              </span>
            ) : (
              ""
            )}
            {item?.nca && activeTab !== "ICD 10 AM Index" ? (
              <span className="item-acs-value">
                {" "}
                <button
                  className="nca-btn"
                  onClick={() => {
                    //  console.log("ACS value:", item?.acs);
                    handleNationalSearchRef(item?.nca);
                  }}
                >
                  Advice
                </button>{" "}
              </span>
            ) : (
              ""
            )}
          </span>
          {item.nonessential && (
            <span
              className="font_violet"
              style={{ marginLeft: !item.description ? "5px" : "0px" }}
            >
              ({highlightText(item.nonessential, searchQuery)})
            </span>
          )}
          {item.nec && (
            <span
              className="font_blue"
              style={{ marginLeft: !item.description ? "5px" : "0px" }}
            >
              {highlightText(item.nec, searchQuery)}
            </span>
          )}
          {item.see && (
            <span className="font_purple">
              {" "}
              – {highlightText(item.see.replace(/^�\s*/, ""), searchQuery)}
            </span>
          )}
          {item.seealso && (
            <span className="font_orange">
              {" "}
              – {highlightText(item.seealso.replace(/^�\s*/, ""), searchQuery)}
            </span>
          )}
          {item.note && (
            <div className="font_yellow">
              <b>Note:</b> {highlightText(item.note, searchQuery)}
            </div>
          )}
          {item.inclusion && (
            <div className="font_green">
              <b>Includes</b> : {highlightText(item.inclusion, searchQuery)}
            </div>
          )}
          {item.useAdditional && (
            <div className="font_blud">
              <b>useAdditional</b> :{" "}
              {highlightText(item.useAdditional, searchQuery)}
            </div>
          )}
          {item.exclusion && (
            <div className="font_red">
              <b>Excludes</b> : {highlightText(item.exclusion, searchQuery)}
            </div>
          )}
          {item.codeas && (
            <div className="font_codeas">
              <b>Codeas</b> : {highlightText(item.codeas, searchQuery)}
            </div>
          )}
          {item.codealso && (
            <div className="font_codealso">
              <b>Codealso</b> : {highlightText(item.codealso, searchQuery)}
            </div>
          )}
          {item.codeto && (
            <div className="font_purple11">
              <b>Codeto</b> : {highlightText(item.codeto, searchQuery)}
            </div>
          )}
          {item.codefirst && (
            <div className="font_codefirst">
              <b>Codefirst</b> : {highlightText(item.codefirst, searchQuery)}
            </div>
          )}
          {item.inclusional && (
            <div className="font_inclusional">
              <b>Inclusional</b> :{" "}
              {highlightText(item.inclusional, searchQuery)}
            </div>
          )}
          {item.definition && (
            <div className="font_pink">
              <b>Definition</b> : {highlightText(item.definition, searchQuery)}
            </div>
          )}

          {item.stylednote && (
            <div className="font_blue">
              <b>Stylednote</b> : {highlightText(item.stylednote, searchQuery)}
            </div>
          )}
        </div>
      </div>
      {localIsOpen && item.children?.length > 0 && (
        <div className="accordion-children">
          {item.children.map((child) => (
            <AccordionItem
              key={child.id}
              item={child}
              activeTab={activeTab}
              searchByCodeId={searchByCodeId}
              searchQuery={searchQuery}
              setActiveTab={setActiveTab}
              dispatch={dispatch}
              setActiveIcon={setActiveIcon}
              isLockedCoder={isLockedCoder}
              firstMatchRef={firstMatchRef}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default React.memo(CodeBookDev);
